

// API Configuration
// In production, set REACT_APP_API_BASE_URL environment variable
// For example: REACT_APP_API_BASE_URL=https://yourdomain.com/chatbot
// For on-premise deployment, API is served from /chatbot/api (base is /chatbot)
const getApiBaseUrl = () => {
  // If explicitly set, use that
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }

  // For production builds, use relative path to /chatbot (code adds /api/...)
  if (process.env.NODE_ENV === 'production') {
    return '/chatbot';
  }

  // For development, prepend the /chatbot prefix because the backend routes are mounted under /chatbot
  // This makes calls like `${API_BASE_URL}/api/widget/settings` resolve to http://localhost:8000/chatbot/api/widget/settings
  return "http://localhost:8000/chatbot";
};

// Widget base URL for embed code (Integration Code in Bot Settings)
// Set REACT_APP_WIDGET_BASE_URL when deploying so the embed script uses your server URL (e.g. https://yourdomain.com)
const getWidgetBaseUrl = () => {
  if (process.env.REACT_APP_WIDGET_BASE_URL) {
    return process.env.REACT_APP_WIDGET_BASE_URL.replace(/\/$/, '');
  }
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  return '';
};

/** React Router basename — must match App.js Router and package.json homepage. */
export const getRouterBasename = () => {
  if (process.env.NODE_ENV === 'development') {
    return '';
  }
  const base = process.env.PUBLIC_URL || '/chatbot';
  return String(base).replace(/\/$/, '') || '';
};

/** True if value looks like a JWT (three base64url segments). */
export const looksLikeJwt = (token) => {
  if (!token || typeof token !== 'string') return false;
  const t = token.trim().replace(/^Bearer\s+/i, '');
  const parts = t.split('.');
  if (parts.length !== 3) return false;
  return parts.every((seg) => seg.length > 0 && /^[A-Za-z0-9_-]+$/.test(seg));
};

/** Decode JWT payload (base64url-safe). */
export const parseJwtPayload = (token) => {
  if (!token || typeof token !== 'string') return null;
  const part = token.split('.')[1];
  if (!part) return null;
  const base64 = part.replace(/-/g, '+').replace(/_/g, '/');
  const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
  return JSON.parse(atob(padded));
};

/** Full path for window.location (includes /chatbot in production). */
export const toAppPath = (path) => {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  const basename = getRouterBasename();
  return basename ? `${basename}${normalized}` : normalized;
};

const API_BASE_URL = getApiBaseUrl();
export const WIDGET_BASE_URL = getWidgetBaseUrl();
export default API_BASE_URL;

